<template>
    <div class="card">
        <div class="bg-blue-light p-2">
            <TitleButton
                :showBtn="false"
                btnTitle="Add New"
                title="Expense Category Summary"
            />
        </div>

        <div class="mt-2 px-2">
            <ExpenseCategorySummaryTable
                :tableData="expenseCategorySummary"
            />
        </div>
        <GlobalLoader />
    </div>
</template>

<script setup>
import {onMounted} from 'vue';
import {useRoute} from 'vue-router'
import TitleButton from '@/components/atom/TitleButton'
import ExpenseCategorySummaryTable from '@/components/molecule/company/report/ExpenseCategorySummaryTable.vue'
import useReport from '@/services/modules/dashboard/report.js'

const {expenseCategorySummary, fetchExpenseCategorySummary} = useReport()
const route = useRoute()
onMounted(() => {
  fetchExpenseCategorySummary(getQuery())
})
function getQuery () {
  return '?company_id=' + route.params.companyId
}

</script>
